import { render, staticRenderFns } from "./overdueSupplyReview.vue?vue&type=template&id=050492b1&scoped=true"
import script from "./overdueSupplyReview.vue?vue&type=script&lang=js"
export * from "./overdueSupplyReview.vue?vue&type=script&lang=js"
import style0 from "./overdueSupplyReview.vue?vue&type=style&index=0&id=050492b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050492b1",
  null
  
)

export default component.exports